/**
 * Shared avatar color palette (readable with white initials on dark
 * surfaces). Reused by comments, header presence, and the access list so
 * the same person gets the same color everywhere.
 */
export const AVATAR_COLOR_PALETTE = [
  '#1890ff',
  '#722ed1',
  '#08979c',
  '#389e0d',
  '#d48806',
  '#c41d7f',
  '#d4380d',
  '#1d39c4',
];

/**
 * Deterministic avatar color per person name, so each collaborator gets a
 * stable, distinct bubble regardless of join order or list position.
 */
export const getAvatarColor = (name?: string | null): string => {
  if (!name) return AVATAR_COLOR_PALETTE[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  }
  return AVATAR_COLOR_PALETTE[hash % AVATAR_COLOR_PALETTE.length];
};
